import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { BASE_API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${BASE_API_URL}/user/manage`;

export const ACTION_TYPES = {
  FETCH_USER_LIST: 'USER/FETCH_USER_LIST',
  FETCH_USER: 'USER/FETCH_USER',
  CREATE_USER: 'USER/CREATE_USER',
  UPDATE_USER: 'USER/UPDATE_USER',
  DELETE_USER: 'USER/DELETE_USER',
  RESET: 'USER/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const UserReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_USER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_USER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_USER):
    case REQUEST(ACTION_TYPES.UPDATE_USER):
    case REQUEST(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_USER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_USER):
    case FAILURE(ACTION_TYPES.CREATE_USER):
    case FAILURE(ACTION_TYPES.UPDATE_USER):
    case FAILURE(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_USER_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_USER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_USER):
    case SUCCESS(ACTION_TYPES.UPDATE_USER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_USER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default UserReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_USER_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesCondition = (condition, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_USER_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort
    },
  })
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_USER,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_USER,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, pagination, condition, pencarian, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_USER,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  if(pencarian === true){
    let condition2 = condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, 10, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, 10, sortTable));
  }
  
  return result;
};

export const nonActiveUser = (id, pagination, condition, pencarian, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.post(`${apiUrl}/non_active/${id}`),
    meta: { successMessage: `Berhasil update pengguna!` },
  });

  if(pencarian === true){
    let condition2 = condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, 10, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, 10, sortTable));
  }

  return result;
};


export const addUserRole = (id, roleId, pagination, condition, pencarian, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.post(`${apiUrl}/authority?user_id=${id}&authority_id=${roleId}`),
    meta: { successMessage: `Berhasil tambah role pengguna!` },
  });

  if(pencarian === true){
    let condition2 = condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, 10, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, 10, sortTable));
  }

  return result;
};

export const deleteUserRole = (id, roleId, pagination, condition, pencarian, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.delete(`${apiUrl}/authority?user_id=${id}&authority_id=${roleId}`),
    meta: { successMessage: `Berhasil hapus role pengguna!` },
  });

  if(pencarian === true){
    let condition2 = condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, 10,  sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, 10, sortTable));
  }

  return result;
};

export const changeUserPassword = (id, entity, pagination, condition, pencarian, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.post(`${apiUrl}/${id}/reset_password`, entity),
    meta: { successMessage: `Berhasil reset password pengguna!` },
  });

  if(pencarian === true){
    let condition2 = condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, 10, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, 10, sortTable));
  }

  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
